(() => {
  if (window.__gowinPdpCtaGuardV1) return;
  window.__gowinPdpCtaGuardV1 = true;

  const root = document.documentElement;
  const activeClass = 'gowin-pdp-cart-cta-visible';
  const styleId = 'GowinPdpCtaGuardV1';
  let observer = null;
  let observedButton = null;

  const ensureStyles = () => {
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      @media screen and (max-width: 749px) {
        html.gowin-pdp-cart-cta-visible whatsapp-chat-by-squadkin,
        html.gowin-pdp-cart-cta-visible [class*="whatsapp-chat"],
        html.gowin-pdp-cart-cta-visible [id*="whatsapp-chat"] {
          opacity: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
          transform: translateY(8px) !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const stop = () => {
    if (observer) observer.disconnect();
    observer = null;
    observedButton = null;
    root.classList.remove(activeClass);
  };

  const init = () => {
    ensureStyles();

    const button = document.querySelector('product-info[id^="MainProduct-"] .product-form__submit');
    if (!button) {
      stop();
      return;
    }

    if (observer && observedButton === button) return;

    stop();
    observedButton = button;
    observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      const visible = Boolean(
        entry &&
        entry.isIntersecting &&
        entry.intersectionRect.width > 0 &&
        entry.intersectionRect.height > 0
      );
      root.classList.toggle(activeClass, visible);
    }, { threshold: [0, 0.01, 0.25] });

    observer.observe(button);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => {
    stop();
    window.setTimeout(init, 0);
  });
  window.addEventListener('pageshow', init);
})();
